import { render, staticRenderFns } from "./WaterBalanceIwa.vue?vue&type=template&id=1ddae3c0&scoped=true&"
import script from "./WaterBalanceIwa.vue?vue&type=script&lang=js&"
export * from "./WaterBalanceIwa.vue?vue&type=script&lang=js&"
import style0 from "./WaterBalanceIwa.vue?vue&type=style&index=0&id=1ddae3c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddae3c0",
  null
  
)

export default component.exports